import { render, staticRenderFns } from "./MinusBox.vue?vue&type=template&id=2f6d0de7&"
import script from "./MinusBox.vue?vue&type=script&lang=js&"
export * from "./MinusBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cschwan/nextcloud/workspace/server/apps-extra/activity/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f6d0de7')) {
      api.createRecord('2f6d0de7', component.options)
    } else {
      api.reload('2f6d0de7', component.options)
    }
    module.hot.accept("./MinusBox.vue?vue&type=template&id=2f6d0de7&", function () {
      api.rerender('2f6d0de7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/vue-material-design-icons/MinusBox.vue"
export default component.exports